<template>
  <div>
    <div class="card p-4 shadow-sm">
      <!-- Campo de búsqueda -->
      <div class="mb-3">
        <input
          type="text"
          class="form-control"
          placeholder="Buscar servicio por nombre"
          v-model="busqueda"
        />
      </div>

      <!-- Toast de alerta -->
      <div
        v-if="mostrarToast"
        class="toast-container position-fixed top-0 end-0 p-3"
        style="z-index: 1055"
      >
        <div class="toast show align-items-center text-white" :class="toastColor">
          <div class="d-flex">
            <div class="toast-body">
              <i :class="iconoToast" class="me-2"></i>
              {{ alerta.mensaje }}
            </div>
            <button type="button" class="btn-close btn-close-white me-2 m-auto" @click="cerrarToast"></button>
          </div>
        </div>
      </div>

      <!-- Encabezado -->
      <div class="d-flex justify-content-between align-items-center mb-4">
        <h3 class="m-0">Servicios Extra</h3>
        <button class="btn btn-success" @click="mostrarFormulario = true">Agregar Servicio</button>
      </div>

      <!-- Formulario -->
      <div v-if="mostrarFormulario" class="mb-4">
        <h5 class="mb-3">Nuevo Servicio</h5>
        <div class="row g-4">
          <div class="col-md-6">
            <label class="form-label">Nombre</label>
            <input v-model="nuevoServicio.Nombre" type="text" class="form-control" />
          </div>
          <div class="col-md-6">
            <label class="form-label">Precio (Q)</label>
            <input v-model.number="nuevoServicio.precio" type="number" min="0.01" step="0.01" class="form-control" />
          </div>
        </div>
        <div class="text-end mt-3">
          <button class="btn btn-primary me-2" @click="guardarServicio">Guardar</button>
          <button class="btn btn-secondary" @click="cancelarFormulario">Cancelar</button>
        </div>
      </div>

      <!-- Tabla -->
      <div class="table-responsive">
        <table class="table table-bordered text-center align-middle">
          <thead class="table-light">
            <tr>
              <th>Nombre</th>
              <th>Precio (Q)</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="servicios.length === 0">
              <td colspan="3">No hay servicios registrados.</td>
            </tr>
            <tr v-for="serv in servicios" :key="serv.IdServicio">
              <td>{{ serv.Nombre }}</td>
              <td>Q.{{ Number(serv.Precio).toFixed(2) }}</td>
              <td>
                <button class="btn btn-primary btn-sm me-2" @click="abrirModal(serv)">Editar</button>
                <button class="btn btn-danger btn-sm" @click="abrirModalEliminar(serv)">Eliminar</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Modal Actualizar -->
      <div v-if="mostrarModal" class="modal-backdrop">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Actualizar Servicio</h5>
            <button type="button" class="btn-close" @click.stop="cerrarModal"></button>
          </div>
          <div class="modal-body">
            <div class="row g-4">
              <div class="col-md-6">
                <label class="form-label">Nombre</label>
                <input v-model="servicioEditar.Nombre" type="text" class="form-control" />
              </div>
              <div class="col-md-6">
                <label class="form-label">Precio (Q)</label>
                <input v-model.number="servicioEditar.precio" type="number" min="0.01" step="0.01" class="form-control" />
              </div>
            </div>
          </div>
          <div class="modal-footer mt-3">
            <button class="btn btn-secondary" @click="cerrarModal">Cancelar</button>
            <button class="btn btn-primary" @click="actualizarServicio">Actualizar</button>
          </div>
        </div>
      </div>

      <!-- Modal Eliminar -->
      <div v-if="mostrarModalEliminar" class="modal-backdrop">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title text-danger">Confirmar Eliminación</h5>
            <button type="button" class="btn-close" @click="cerrarModalEliminar"></button>
          </div>
          <div class="modal-body">
            <p>¿Eliminar el servicio <strong>{{ servicioEliminar?.Nombre }}</strong>?</p>
          </div>
          <div class="modal-footer mt-3">
            <button class="btn btn-secondary" @click="cerrarModalEliminar">Cancelar</button>
            <button class="btn btn-danger" @click="confirmarEliminar">Eliminar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { API_URL } from "@/config/config.js";
import debounce from "lodash/debounce";

export default {
  name: "ServiciosExtraHotel",
  data() {
    return {
      servicios: [],
      mostrarFormulario: false,
      mostrarModal: false,
      mostrarModalEliminar: false,
      busqueda: "",
      servicioEditar: null,
      servicioEliminar: null,
      mostrarToast: false,
      alerta: { mensaje: "", tipo: "success" },
      nuevoServicio: {
        Nombre: "",
        precio: ""
      }
    };
  },
  watch: {
    busqueda() {
      this.buscarServicioDebounce();
    }
  },
  created() {
    this.buscarServicioDebounce = debounce(this.buscarServicio, 400);
  },
  computed: {
    toastColor() {
      return this.alerta.tipo === "success" ? "bg-success" : "bg-danger";
    },
    iconoToast() {
      return this.alerta.tipo === "success" ? "bi bi-check-circle" : "bi bi-exclamation-circle";
    }
  },
  methods: {
    cerrarToast() {
      this.mostrarToast = false;
    },
    mostrarAlerta(mensaje, tipo = "success") {
      this.alerta = { mensaje, tipo };
      this.mostrarToast = true;
      setTimeout(this.cerrarToast, 3000);
    },
    async obtenerServicios() {
      try {
        const { data } = await axios.get(`${API_URL}/servicios-extra`);
        this.servicios = data;
      } catch (error) {
        console.error(error);
      }
    },
    async buscarServicio() {
      if (this.busqueda.trim() === "") {
        this.obtenerServicios();
        return;
      }
      try {
        const { data } = await axios.get(`${API_URL}/servicios-extra/buscar/${this.busqueda}`);
        this.servicios = data;
      } catch (error) {
        if (error.response?.status === 404) {
          this.servicios = [];
          this.mostrarAlerta("No se encontraron servicios.", "warning");
        } else {
          console.error(error);
          this.mostrarAlerta("Error al buscar servicios.", "danger");
        }
      }
    },
    async guardarServicio() {
      const { Nombre, precio } = this.nuevoServicio;
      if (!Nombre || !precio) {
        this.mostrarAlerta("Todos los campos son obligatorios", "danger");
        return;
      }
      try {
        await axios.post(`${API_URL}/servicios-extra`, this.nuevoServicio);
        this.mostrarAlerta("Servicio agregado", "success");
        this.nuevoServicio = { Nombre: "", precio: "" };
        this.mostrarFormulario = false;
        this.obtenerServicios();
      } catch (error) {
        console.error(error);
        this.mostrarAlerta("Error al guardar", "danger");
      }
    },
    abrirModal(servicio) {
      this.servicioEditar = { ...servicio };
      this.mostrarModal = true;
    },
    cerrarModal() {
      this.servicioEditar = null;
      this.mostrarModal = false;
    },
    async actualizarServicio() {
      try {
        await axios.put(`${API_URL}/servicios-extra/${this.servicioEditar.IdServicio}`, this.servicioEditar);
        this.mostrarAlerta("Servicio actualizado", "success");
        this.cerrarModal();
        this.obtenerServicios();
      } catch (error) {
        console.error(error);
        this.mostrarAlerta("Error al actualizar", "danger");
      }
    },
    abrirModalEliminar(servicio) {
      this.servicioEliminar = { ...servicio };
      this.mostrarModalEliminar = true;
    },
    cerrarModalEliminar() {
      this.mostrarModalEliminar = false;
      this.servicioEliminar = null;
    },
    async confirmarEliminar() {
      if (!this.servicioEliminar) return;
      try {
        await axios.delete(`${API_URL}/servicios-extra/${this.servicioEliminar.IdServicio}`);
        this.mostrarAlerta("Servicio eliminado", "success");
        this.obtenerServicios();
      } catch (error) {
        console.error(error);
        this.mostrarAlerta("Error al eliminar", "danger");
      } finally {
        this.cerrarModalEliminar();
      }
    },
    cancelarFormulario() {
      this.mostrarFormulario = false;
      this.nuevoServicio = { Nombre: "", precio: "" };
    }
  },
  mounted() {
    this.obtenerServicios();
  }
};
</script>

<style scoped>
.modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
}
.modal-content {
  background: #fff;
  width: 450px;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
}
</style>
